export default __webpack_public_path__ + "video-ab84b4a.png";